<template>
	<ul
		class="list-none"
		:class="[`col-count-1 md:col-count-${columnsCount} lg:col-count-1`]"
	>
		<template v-for="(item, index) in items" :key="index">
			<li :class="[listClass, item.listClass]">
				<div
					class="relative flex"
					:class="[itemsPaddingY, showListIcon ? iconGap : '']"
				>
					<span
						v-if="showListIcon"
						class="absolute left-0"
						:class="[
							iconClass,
							iconTop,
							iconVerticalAlign,
							itemsPaddingY,
						]"
					>
						<slot name="icon">
							<IconListDot :class="iconClass" />
						</slot>
					</span>
					<slot
						:name="`${
							item.slug ? item.slug : _kebabCase(item.label)
						}`"
						:item="item"
						:index="index"
					>
						<div v-if="item.label">{{ item.label }}</div>
					</slot>
				</div>
			</li>
		</template>
	</ul>
</template>

<script setup>
import { kebabCase as _kebabCase } from 'lodash-es'
import IconListDot from '@/assets/svg/common/ico-list-dot.svg'

const props = defineProps({
	items: {
		type: Array,
		required: true,
	},
	itemsPaddingY: {
		type: String,
		required: false,
		default: 'py-1',
	},
	columnsCount: {
		type: Number,
		required: false,
		default: 1,
	},
	showListIcon: {
		type: Boolean,
		required: false,
		default: true,
	},
	listIcon: {
		type: String,
		required: false,
		default: 'img/common/ico-list-dot.svg',
	},
	listClass: {
		type: String,
		required: false,
		default: '',
	},
	iconClass: {
		type: String,
		required: false,
		default: '',
	},
	iconWidth: {
		type: String,
		required: false,
		default: '',
	},
	iconHeight: {
		type: String,
		required: false,
		default: '',
	},
	iconVerticalAlign: {
		type: String,
		required: false,
		default: 'items-start',
	},
	iconTop: {
		type: String,
		required: false,
		default: 'top-0',
	},
	iconColor: {
		type: String,
		required: false,
		default: 'text-gray-700',
	},
	iconGap: {
		type: String,
		required: false,
		default: 'pl-8',
	},
	fontSize: {
		type: String,
		required: false,
		default: '',
	},
})
</script>
